import { toEthereumAddress } from './EthereumAddress';
import { isENSNameFormatIgnoreCase, toENSName } from './ENSName';
export function toEthereumAddressOrENSName(str) {
    return isENSNameFormatIgnoreCase(str) ? toENSName(str) : toEthereumAddress(str);
}
//# sourceMappingURL=toEthereumAddressOrENSName.js.map